import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import { IoClose } from "react-icons/io5";

import { MonetaLogo } from "@/components/atoms/MonetaLogo";
import { useScrollLock, useViewportHeight } from "@/hooks";

import * as s from "./styles";

export interface NavLinkProps {
  path: string;
  label: React.ReactNode | string;
  key: string;
}

export interface NavigationProps {
  links: NavLinkProps[];
}

export const Navigation = ({ links }: NavigationProps) => {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const { boxStyle: viewportHeight } = useViewportHeight();

  useScrollLock(isMenuExpanded);

  const handleMenuClick = (e: React.SyntheticEvent) => {
    e.preventDefault();
    setIsMenuExpanded(!isMenuExpanded);
  };

  return (
    <s.Container>
      <s.FullWidthNav>
        <s.LogoWrapper to="/">
          <MonetaLogo height={64} />
        </s.LogoWrapper>

        {links.map((link, index) => (
          <s.Link to={link?.path} key={index}>
            {link?.label}
          </s.Link>
        ))}
        <s.RightContainer>
          <s.LogoutLink to="/logout">Logout</s.LogoutLink>
          <s.LogoutLink to="/settings">Settings</s.LogoutLink>
        </s.RightContainer>
      </s.FullWidthNav>

      <s.ResponsiveNav>
        <s.MenuButton onClick={handleMenuClick}>
          <s.MenuIcon /> Menu
        </s.MenuButton>

        <AnimatePresence initial={false}>
          {isMenuExpanded && (
            <s.ResponsiveMenu
              initial="hidden"
              animate="visible"
              exit="hiden"
              variants={listAnimationProps}
            >
              <s.CloseMenuButton onClick={handleMenuClick}>
                <IoClose />
              </s.CloseMenuButton>

              <s.MenuItems style={viewportHeight}>
                {links.map((link, index) => (
                  <s.MenuItem variants={itemAnimationProps} key={index}>
                    <s.MenuLink to={link?.path}>{link?.label}</s.MenuLink>
                  </s.MenuItem>
                ))}

                <s.ChangePasswordWrapper variants={itemAnimationProps}>
                  <s.LogoutNavLink to="/logout">Logout</s.LogoutNavLink>
                </s.ChangePasswordWrapper>
                <s.LogoutButtonWrapper variants={itemAnimationProps}>
                  <s.LogoutNavLink to="/settings">Settings</s.LogoutNavLink>
                </s.LogoutButtonWrapper>
              </s.MenuItems>
            </s.ResponsiveMenu>
          )}
        </AnimatePresence>
      </s.ResponsiveNav>
    </s.Container>
  );
};

const listAnimationProps = {
  visible: {
    opacity: 1,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      when: "afterChildren",
    },
  },
};

const itemAnimationProps = {
  visible: {
    opacity: 1,
    y: 0,
  },
  hidden: {
    opacity: 0,
    y: 40,
    transition: {
      when: "afterChildren",
    },
  },
};

const defaultLinks: NavLinkProps[] = [
  { key: "1", path: "/patients", label: "Patients" },
  { key: "2", path: "/activity-library", label: "Activity Library" },
  // { key: "3", path: "/change-password", label: "Reset Password" },
];

Navigation.defaultProps = {
  links: defaultLinks,
};
